import { ApiGetRequest } from './api-get-request';

export class TicketReservationRequest extends ApiGetRequest
{
    public constructor(webapiBasepath: string)
    {
        super('ticketreservation', null, null, webapiBasepath);
    }
}
